import axiosInstance from './instance';

const instance = axiosInstance();

export const dashBoardCount = async (userId) => {
    try {
        const response = await instance.get(`/reports/status/count/${userId}/university-applications`);
        return response;
    } catch (error) {
        return error;
    }
}